import React, { useState } from "react"

import { Swiper, SwiperProps, SwiperSlide } from "swiper/react"
import { Swiper as SwiperClass } from "swiper"
import { Controller, Keyboard } from "swiper"

import "swiper/scss"
import "swiper/scss/pagination"
import "./slider-pagination.module.scss"

interface SliderControllerProps {
  activeIndex: number
  control?: SwiperClass
  handlePagination: (swiper: SwiperClass) => void
  numberOfReviews: number
  onPaginationClick: (index: number) => void
}

export const SliderPagination = ({
  activeIndex,
  control,
  handlePagination,
  numberOfReviews,
  onPaginationClick,
}: SliderControllerProps) => {
  const [indexClass, setIndexClass] = useState("")

  const dotsPerSlide = 3,
    hasMoreReviewsThanDots = numberOfReviews >= dotsPerSlide,
    reviewsCountList = Array.from(Array(numberOfReviews))

  const swiperControlProps: SwiperProps = {
    centeredSlides: true,
    centeredSlidesBounds: hasMoreReviewsThanDots ? false : true,
    centerInsufficientSlides: true,
    className: "fr-slider-pagination__control",
    initialSlide: 0,
    keyboard: {
      enabled: true,
    },
    modules: [Controller, Keyboard],
    preventInteractionOnTransition: true,
    roundLengths: true,
    slidesPerView: hasMoreReviewsThanDots ? dotsPerSlide : dotsPerSlide - 1,
    slideToClickedSlide: true,
    onActiveIndexChange: swiper => {
      if (hasMoreReviewsThanDots) {
        if (swiper.isBeginning)
          setIndexClass("fr-slider-pagination__slide--first")
        else if (swiper.previousIndex === 0)
          setIndexClass("fr-slider-pagination--disable-transition")
        else if (swiper.isEnd)
          setIndexClass("fr-slider-pagination__slide--last")
        else setIndexClass("")
      }
    },
    onSwiper: swiper => {
      if (hasMoreReviewsThanDots && swiper.isBeginning)
        setIndexClass("fr-slider-pagination__slide--first")
      handlePagination(swiper)
    },
    controller: {
      control,
    },
  }

  const paginationClasses = [
    "u-flex-center-align",
    "fr-container",
    "fr-slider-pagination",
    indexClass,
  ]
    .filter(c => c)
    .join(" ")

  return (
    <div className={paginationClasses}>
      <Swiper {...swiperControlProps}>
        {reviewsCountList.map((_, index) => {
          const slideIndex = index + 1,
            activeSlideClass =
              activeIndex == slideIndex ? "fr-slider-pagination--active" : ""
          return (
            <SwiperSlide className={activeSlideClass} key={index}>
              <div
                className="fr-slider-pagination__dot"
                onClick={() => onPaginationClick(slideIndex)}
              >
                <span />
              </div>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}
